/**
 * Candidate-facing reason options.
 *
 * MIRRORS proxy-server/lib/bookingReasons.js. Kept in sync deliberately rather
 * than shared, because the frontend cannot import from proxy-server — and a
 * mismatch would let the UI offer a choice the server then rejects.
 */
export const OTHER = 'other';

export interface ReasonOption {
  code: string;
  label: string;
}

export const CANCEL_REASONS: ReasonOption[] = [
  { code: 'no_longer_interested', label: 'I’m no longer interested in the role' },
  { code: 'accepted_other_offer', label: 'I accepted another offer' },
  { code: 'timing_not_right', label: 'The timing isn’t right for me at the moment' },
  { code: 'scheduling_conflict', label: 'I have a scheduling conflict' },
  { code: 'process_too_long', label: 'The process is taking too long' },
  { code: OTHER, label: 'Other' },
];

export const RESCHEDULE_REASONS: ReasonOption[] = [
  { code: 'scheduling_conflict', label: 'Something came up at the same time' },
  { code: 'unwell', label: 'I’m unwell' },
  { code: 'need_preparation', label: 'I need more time to prepare' },
  { code: 'travel', label: 'Travel or holiday' },
  { code: 'work_commitment', label: 'A work commitment I can’t move' },
  { code: OTHER, label: 'Other' },
];

export const MAX_NOTE_LENGTH = 500;
export const MIN_NOTE_LENGTH = 3;
